export default __webpack_public_path__ + "0011e31d97f03873b7617277d791e83f.svg";